import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * Component that handles user impersonation initialization.
 * Receives a user id (that maps to user in OIDC Auth Server) from the route,
 * stores it in session storage, and reloads the page to activate impersonation.
 */
@Component({
  selector: 'pl-impersonate',
  template: `
    <div class="impersonation-loading">
      <p>Starting impersonation...</p>
    </div>
  `,
  styles: [
    `
      .impersonation-loading {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        font-size: 1.2rem;
      }
    `,
  ],
})
export class ImpersonateComponent implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    const userId = this.route.snapshot.paramMap.get('user_id');

    if (!userId) {
      // No user ID provided, redirect to home
      this.router.navigate(['/']);
      return;
    }

    // Store the impersonation target user ID in session storage
    sessionStorage.setItem('impersonation_target_user_id', userId);
    // Reload the page to trigger the impersonation flow
    // The PlImpersonationService will detect the impersonation_target_user_id and
    // perform the token exchange
    window.location.href = '/';
  }
}
